import { useQuery } from 'react-query';
import axios from 'axios';
import { desktopRecorderOnlyEnv } from '../config/recordingMode';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export interface RecorderInstallConfig {
  version: string;
  downloadUrl: string | null;
  downloadFileName: string;
  dotnetDesktopRuntimeUrl: string;
  defaultInstallDir: string;
  protocol: string;
}

export interface RecordingConfig {
  desktopRecorderOnly: boolean;
  desktopRecorderEnabled: boolean;
  recorderInstall?: RecorderInstallConfig;
}

async function fetchRecordingConfig(): Promise<RecordingConfig> {
  const { data } = await axios.get<RecordingConfig>(`${API_BASE}/config/recording`);
  return data;
}

export function useRecordingConfig() {
  const query = useQuery('recording-config', fetchRecordingConfig, {
    staleTime: 60_000,
    retry: 1,
  });

  const desktopRecorderOnly = query.data?.desktopRecorderOnly ?? desktopRecorderOnlyEnv;
  const desktopRecorderEnabled = query.data?.desktopRecorderEnabled ?? true;

  return {
    ...query,
    desktopRecorderOnly: desktopRecorderOnly && desktopRecorderEnabled,
    desktopRecorderEnabled,
  };
}
